// extracted by mini-css-extract-plugin
export default {"container":"add_to_folders_dropdown-module__container--3YVNO"};